export const questions: Array<[string, string]> = [
  [
    'Per chi è questa collezione?',
    "Per insegnanti di scienze, tecnologia, fisica, geografia e materie affini della scuola secondaria e degli istituti tecnici che vogliono lezioni sulle energie rinnovabili più chiare e pronte all'uso.",
  ],
  ['In che formato ricevo il materiale?', 'In PDF scaricabili, da consultare su computer, tablet o da stampare.'],
  ['Quando ricevo l’accesso?', 'Subito dopo il pagamento ricevi via email il link di accesso.'],
  [
    'Serve una preparazione specifica sulle energie rinnovabili?',
    'No. I volumi partono dai fondamenti e spiegano ogni concetto passo passo, con schemi ed esempi.',
  ],
  [
    'Posso usarlo con i miei studenti?',
    'Sì, è pensato per l’uso in classe: attività, esperimenti, casi di studio e verifiche pronti.',
  ],
  ['C’è una garanzia?', 'Sì, hai 7 giorni di garanzia di soddisfazione.'],
];
